import { useState } from 'react'
import { Link } from 'react-router-dom'
import { forgotPassword } from '@/api/auth'
import toast from 'react-hot-toast'

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [sent, setSent] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!email) {
      toast.error('Please enter your email address')
      return
    }

    setLoading(true)
    try {
      await forgotPassword({ email })
      setSent(true)
      toast.success('Reset instructions sent to your email')
    } catch (err: unknown) {
      const msg = (err as { response?: { data?: { detail?: string } } })?.response?.data?.detail || 'Failed to send reset email'
      toast.error(msg)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      background: 'var(--color-bg)',
      padding: '2rem',
    }}>
      <div style={{
        maxWidth: 420,
        width: '100%',
        animation: 'slideUp 0.3s ease-out',
      }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <span style={{
            fontFamily: 'var(--font-heading)',
            fontSize: '1.8125rem',
            fontWeight: 700,
            background: 'linear-gradient(90deg, #0061D0, #009974)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}>
            twasta.ai
          </span>
        </div>

        <div style={{
          background: 'var(--color-bg-secondary)',
          border: '1px solid var(--color-border)',
          borderRadius: 'var(--radius-lg)',
          padding: '2rem',
        }}>
          {sent ? (
            <div style={{ textAlign: 'center' }}>
              <div style={{
                width: 56,
                height: 56,
                borderRadius: '50%',
                background: 'var(--color-accent-weak)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 1.25rem',
              }}>
                <span className="material-icons" style={{ fontSize: 29, color: 'var(--color-accent)' }}>
                  mark_email_read
                </span>
              </div>
              <h2 style={{ fontSize: '1.3125rem', fontWeight: 600, marginBottom: '0.75rem' }}>
                Check Your Email
              </h2>
              <p style={{
                color: 'var(--color-text-secondary)',
                fontSize: '0.9375rem',
                lineHeight: 1.7,
                marginBottom: '1.5rem',
              }}>
                If an account exists for <strong style={{ color: 'var(--color-text)' }}>{email}</strong>,
                you will receive password reset instructions shortly.
              </p>
              <Link to="/" className="btn btn-primary">
                Back to Login
              </Link>
            </div>
          ) : (
            <>
              <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
                <span className="material-icons" style={{
                  fontSize: 41,
                  color: 'var(--color-accent)',
                  marginBottom: '0.75rem',
                  display: 'block',
                }}>
                  lock_reset
                </span>
                <h2 style={{ fontSize: '1.3125rem', fontWeight: 600, marginBottom: '0.375rem' }}>
                  Forgot Password?
                </h2>
                <p style={{
                  color: 'var(--color-text-secondary)',
                  fontSize: '0.9375rem',
                }}>
                  Enter your email and we'll send you reset instructions.
                </p>
              </div>

              <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
                <div>
                  <label htmlFor="fp-email">Email Address</label>
                  <input
                    id="fp-email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="you@company.com"
                    autoComplete="email"
                    required
                    autoFocus
                  />
                </div>

                <button
                  type="submit"
                  className="btn btn-primary btn-lg w-full"
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <span className="spinner" style={{ width: 18, height: 18, borderWidth: 2 }} />
                      Sending...
                    </>
                  ) : (
                    <>
                      <span className="material-icons" style={{ fontSize: 19 }}>send</span>
                      Send Reset Link
                    </>
                  )}
                </button>
              </form>
            </>
          )}
        </div>

        <div style={{
          textAlign: 'center',
          marginTop: '1.25rem',
          fontSize: '0.9375rem',
          color: 'var(--color-text-secondary)',
        }}>
          Remember your password?{' '}
          <Link to="/">Sign in</Link>
        </div>
      </div>
    </div>
  )
}
